;(function() {
/* @ngInject */
function ModalDiplom($uibModal, $rootScope) {
    let zdroj;
    return function init(zdroj_) {
        zdroj = zdroj_;
        return { add };
    };

    function open(options = {}) {
        return $uibModal.open(angular.extend({
            templateUrl: "/app/shared/modal-diplom/modal-diplom.html",
            controller: "ModalDiplomController",
            controllerAs: "vm",
            bindToController: true,
            size: "md",
            backdrop: "static",
            resolve: {
                zdroj: () => zdroj
            }
        }, options));
    }

    function add(scope = {}) {
        return open({ scope: angular.extend($rootScope.$new(true), scope), zdroj})
    }
}

/* @ngInject */
function ModalDiplomController($uibModalInstance, zdroj) {
    let vm = this;

    vm.zdroj = zdroj;

    vm.model = {
        identity: vm.zdroj === "OP" ? "yes" : (vm.zdroj === "DIPLOM" ? "no" : null),
        register: vm.zdroj === "DIPLOM" ? "yes" : null
    };

    vm.attrs = {
        identity: [{label: "yes", value: "yes"}, {label: "no", value: "no"}],
        register: [{label: "diplom.yesWithSendEmail", value: "yes"}, {label: "no", value: "no"}]
    };

    vm.submit = () => {
        let result = null;
        if (vm.model.identity === "yes") {
            result = "OP";
        } else if (vm.model.identity === "no" && vm.model.register === "yes") {
            result = "DIPLOM";
        }
        $uibModalInstance.close(result);
    }
}

angular.module("firmaren")
    .factory("ModalDiplom", ModalDiplom)
    .controller("ModalDiplomController", ModalDiplomController);
}());
